import { useMemo } from 'react';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetProjectVersions } from 'api/queries/getProjectVersions.query';

export const useGetCurrentFocusedProjectData = () => {
    const { contract, project } = useProjectTreeStore();

    const { data: versions } = useQueryGetProjectVersions({
        projectId: project?.id,
        contractId: contract?.id,
    });

    const [latestVersion, baselineVersion] = useMemo(() => {
        return [
            versions?.find((version) => version.isLatest),
            versions?.find((version) => version.isDesignatedBaseline),
        ];
    }, [versions]);

    return { contract, project, latestVersion, baselineVersion };
};
